module.exports = __webpack_public_path__ + "static/media/download-bg-banner-graphic.cdef16d0.png";